// extracted by mini-css-extract-plugin
export default {"root":"BlockFooter_root__iw2Cf","media":"BlockFooter_media__UKdnn","text":"BlockFooter_text__rD3Gc"};